












import { Vue, Component, Prop, Ref } from 'vue-property-decorator'

@Component
export default class TableOfContentToggleMenu extends Vue {
  @Prop() readonly header!: string
  @Prop() readonly anchor!: string
  @Prop() readonly parent!: Vue

  @Ref('submenu-content') readonly submenuContent!: HTMLElement

  isMenudisplayed = false
  containsSubmenu = false

  setContainsSubmenu () {
    this.containsSubmenu = this.submenuContent.getElementsByClassName('sub-menu-list').length > 0
  }

  toggleMenu () {
    this.isMenudisplayed = !this.isMenudisplayed
  }

  beforeMount () {
    this.parent.$on('has-build-menu', this.setContainsSubmenu)
  }

  beforeDestroy () {
    this.parent.$off('has-build-menu')
  }
}

